const termsSections = [
  {
    title: '1. Acceptance of these terms',
    body: [
      'These Terms of Service govern your access to and use of AgenticHire, including our marketplace, listing tools, messaging, checkout, account features, and related services. By creating an account, browsing listings, submitting a seller listing, purchasing a service, or otherwise using the platform, you agree to these terms.',
      'If you use AgenticHire on behalf of a company or other organization, you represent that you have authority to bind that organization to these terms.',
    ],
  },
  {
    title: '2. What AgenticHire provides',
    body: [
      'AgenticHire is a marketplace for discovering, buying, and selling packaged AI agent services. Sellers create listings that describe their services, pricing, delivery timelines, revisions, buyer input requirements, and other terms. Buyers can review listings, place orders, submit project information, and communicate with sellers.',
      'AgenticHire provides marketplace infrastructure. We are not a party to the service contract between a buyer and seller, and we do not guarantee a seller’s work, business outcome, revenue result, compliance posture, or the performance of any AI model, workflow, or third-party integration.',
    ],
  },
  {
    title: '3. Accounts and eligibility',
    body: [
      'You must provide accurate account information and keep your login credentials secure. You are responsible for activity that occurs under your account.',
      'You may not use AgenticHire if you are prohibited from doing so under applicable law, if you are subject to relevant sanctions restrictions, or if we have previously suspended or removed your account for violating these terms.',
    ],
  },
  {
    title: '4. Seller responsibilities',
    body: [
      'Sellers are responsible for the accuracy of their listings, including claims about capabilities, deliverables, pricing, delivery time, required buyer inputs, data handling, limitations, and supported integrations.',
      'Sellers must deliver services professionally, communicate clearly, honor the scope stated in their listing or order conversation, and comply with applicable laws, platform policies, third-party terms, and data protection obligations.',
      'Sellers may not list services that are deceptive, unsafe, unlawful, infringing, spam-related, intended to enable fraud, or designed to bypass platform payments or protections.',
    ],
  },
  {
    title: '5. Buyer responsibilities',
    body: [
      'Buyers are responsible for reviewing listing details before ordering and for providing accurate, complete, and lawful project information, credentials, files, or access needed for the seller to perform the service.',
      'Buyers should not share sensitive, regulated, confidential, or third-party data unless the listing and seller are appropriate for that use and the buyer has the right to share that information.',
      'Buyers are responsible for reviewing delivered work before using it in production, sending it externally, making business decisions from it, or relying on it for legal, medical, financial, employment, safety, or other high-impact purposes.',
    ],
  },
  {
    title: '6. Payments, fees, and payouts',
    body: [
      'Payments may be processed by Stripe or another payment provider. By making or receiving payments through AgenticHire, you agree to the applicable payment provider terms.',
      'AgenticHire may charge platform fees, payment processing fees, subscription fees, or other fees disclosed at checkout, in seller tools, or elsewhere on the platform. Seller payouts may be delayed, withheld, or reversed due to payment disputes, fraud reviews, refunds, chargebacks, compliance checks, or payment provider requirements.',
      'Users may not move transactions off-platform to avoid fees, payment protections, or marketplace policies.',
    ],
  },
  {
    title: '7. Orders, cancellations, refunds, and disputes',
    body: [
      'Order scope, timelines, revisions, and deliverables are based on the listing details and any written agreement between buyer and seller through AgenticHire.',
      'Refunds, cancellations, and dispute outcomes may depend on order status, seller performance, buyer cooperation, payment provider rules, and the evidence available to AgenticHire. We may, but are not obligated to, help facilitate communication or dispute review.',
      'AgenticHire may issue refunds, credits, account adjustments, or other remedies at our discretion where we believe it is appropriate or required by law.',
    ],
  },
  {
    title: '8. AI outputs and third-party services',
    body: [
      'Services listed on AgenticHire may use AI models, automation tools, APIs, software, data providers, and third-party platforms. Outputs may be incomplete, inaccurate, biased, stale, or unsuitable for a particular use.',
      'Users are responsible for evaluating outputs and ensuring their use complies with applicable laws, third-party terms, internal policies, and professional standards. AgenticHire does not warrant that any AI output will be accurate, original, non-infringing, secure, or fit for a particular purpose.',
    ],
  },
  {
    title: '9. Content and intellectual property',
    body: [
      'You retain ownership of content you submit to AgenticHire, such as listing copy, project briefs, messages, files, and profile information. You grant AgenticHire a license to host, store, display, process, transmit, and use that content as needed to operate, secure, improve, and promote the platform.',
      'Sellers must have the rights needed to provide their services and deliver work to buyers. Buyers receive rights to delivered work only as described in the listing, order terms, seller agreement, or applicable law.',
      'You may not copy, scrape, resell, reverse engineer, or misuse AgenticHire content, platform data, software, designs, trademarks, or marketplace listings except as permitted by us in writing.',
    ],
  },
  {
    title: '10. Prohibited conduct',
    body: [
      'You may not use AgenticHire to violate laws, infringe rights, distribute malware, send spam, impersonate others, manipulate reviews, interfere with platform security, harvest data, bypass access controls, submit false information, or engage in fraud, abuse, harassment, or deceptive conduct.',
      'You may not use the platform or any seller service to create or support illegal, harmful, discriminatory, exploitative, or high-risk activities.',
    ],
  },
  {
    title: '11. Suspension and termination',
    body: [
      'We may suspend, restrict, or terminate access to AgenticHire if we believe a user has violated these terms, created risk for the platform or other users, failed payment or compliance checks, or used the platform in a way that may cause harm.',
      'You may stop using AgenticHire at any time. Certain obligations, including payment obligations, dispute obligations, intellectual property provisions, disclaimers, limits of liability, and indemnity obligations, survive termination.',
    ],
  },
  {
    title: '12. Disclaimers and limitation of liability',
    body: [
      'AgenticHire is provided on an "as is" and "as available" basis. To the fullest extent permitted by law, we disclaim warranties of merchantability, fitness for a particular purpose, non-infringement, availability, accuracy, and reliability.',
      'To the fullest extent permitted by law, AgenticHire will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, lost profits, lost data, business interruption, or damages arising from seller services, buyer materials, AI outputs, third-party services, or payment provider actions.',
    ],
  },
  {
    title: '13. Changes to the platform or terms',
    body: [
      'We may update AgenticHire, change features, modify fees, or revise these terms from time to time. If changes are material, we will take reasonable steps to notify users. Continued use of the platform after changes become effective means you accept the updated terms.',
    ],
  },
  {
    title: '14. Contact',
    body: [
      'Questions about these terms can be sent to AgenticHire through the contact channel made available on the platform.',
    ],
  },
];

export function TermsPage() {
  return (
    <section className="page-shell legal-page">
      <div className="detail-panel legal-document">
        <span className="eyebrow">Terms</span>
        <h1>AgenticHire Terms of Service</h1>
        <p className="legal-updated">Effective date: April 27, 2026</p>
        <p>
          These terms are a general platform agreement for AgenticHire. They are not legal advice and should be
          reviewed by counsel before production use.
        </p>

        {termsSections.map((section) => (
          <section key={section.title} className="legal-section">
            <h2>{section.title}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
    </section>
  );
}
